export default __webpack_public_path__ + "static/sliding_door_w.46f378e1cbe86b683dfab39c7d6c9155.svg";